import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import habout from "./header.vue";
import links from "./footer.vue";
import works from "./works.vue";

// const about = {component: habout};
// const link = {component: links};
// const work = {component: works}

Vue.use(VueRouter);

const routes = [
  { path: "/", name: 'home', component: habout },
  { path: "/works", name: 'myworks', component: works },
  { path: "/links", name: 'contact', component: links }
];

const router = new VueRouter({routes})

new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js